import { render, staticRenderFns } from "./SliderV2.vue?vue&type=template&id=5996fded&"
import script from "./SliderV2.vue?vue&type=script&lang=js&"
export * from "./SliderV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports